import styled from "styled-components";
import StyledButton from "../../../basic/styledButton/StyledButton";
import DesignConstants from "../../../constants/DesignConstants";
import StyledButtonWithIcon from "../../../basic/styledButtonWithIcon/StyledButtonWithIcon";

// Grows to fill the remaining viewport height (requires hasFullHeightContent on the header
// wrapper) so the sticky CTA footer is pushed to the bottom and never overlaps the last item.
export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};
    flex: 1 0 auto;
`;

export const SyncStatusWrapper = styled.div`
    margin-bottom: ${DesignConstants.SPACES.XS};
`;

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const ExercisesContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};

    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        display: flex;
        flex-direction: column;
    }
`;

export const StyledButtonWithoutIcon = styled(StyledButton)`
    min-width: 30% !important;
    justify-content: center;
    /* !important is required to override the base button's "&.NONE" padding rule */
    padding: ${DesignConstants.SPACES.XS} ${DesignConstants.SPACES.M} !important;

    & > div {
        flex: 0 1 auto;
        text-align: center;
    }
`;

export const AddExerciseButton = styled(StyledButtonWithIcon)`
    align-self: start;
`;

export const FinishTestButton = styled(StyledButtonWithIcon)`
    & > div {
        white-space: normal;
    }
`;

export const ExercisePointsHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        flex-direction: column;
        gap: ${DesignConstants.SPACES.S};
    }
`;

export const TotalPointsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${DesignConstants.SPACES.XS};

    @media (max-width: ${DesignConstants.BREAKPOINTS.MD - 1}px) {
        justify-content: flex-end;
    }
`;

export const TotalPoints = styled.p`
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
    font-size: ${DesignConstants.FONT_SIZES.M};
    text-align: right;
`;

export const TotalPointsText = styled.p`
    font-size: ${DesignConstants.FONT_SIZES.M};
    text-align: right;
`;

export const ToggleSwitchWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${DesignConstants.SPACES.XS};
`;
